import { useEffect, useMemo } from 'react'
import { useBlocker, useLocation } from 'react-router'
import { observer } from 'mobx-react-lite'
import { LINK_CHATBOT_GUIDELINES } from 'shared/constants/links'
import { ChatbotStatus } from 'entities/Chatbot'
import { GuidelineAlert, GuidelineMemoryStore } from 'widgets/GuidelineAlert'
import { ChatbotDialogProvider, ChatbotProvider, useChatbotContext } from 'pages/chatbot/context'
import {
  ChatbotLayout,
  ChatbotLayoutContent,
  ChatbotLayoutWrapper,
  DialogLayout,
  RootLayout,
} from 'pages/chatbot/ui'
import { ChatbotBody } from 'pages/chatbot/ui/ChatbotEdit'
import { ChatbotEditHead } from 'pages/chatbot/pages/chatbotEdit/ui/ChatbotEditHead'
import { DialogEmpty } from 'pages/chatbot/ui/ChatbotDialog/DialogEmpty'
import styles from './styles.module.scss'

export const ChatbotNew = observer(() => {
  const { state: payload } = useLocation()
  const {
    model,
    enrollment,
    isDraggingCondition,
    initResources,
    confirmCreateChatbot,
    checkChanges,
    loadChatbot,
  } = useChatbotContext()
  const guidelineMemoryStore = useMemo(() => new GuidelineMemoryStore(), [])
  const blocker = useBlocker(() => {
    const hasChanges = checkChanges()

    return hasChanges
  })

  useEffect(() => {
    if (payload?.duplicateId) {
      loadChatbot(payload.duplicateId, (data) => {
        model.syncOrigin({
          ...data,
          name: `Copy of ${data.name}`,
          status: ChatbotStatus.Draft,
          is_active: false,
        })
      })
      return
    }

    if (payload) model.syncOrigin(payload)
  }, [payload])

  useEffect(() => {
    if (blocker.state === 'blocked') confirmCreateChatbot(blocker)
  }, [blocker.state])

  useEffect(() => {
    initResources()
    enrollment.initFilters()
  }, [])

  return (
    <ChatbotLayout>
      <ChatbotLayoutWrapper>
        {!payload?.duplicateId && (
          <GuidelineAlert
            className={styles.guidelineAlert}
            store={guidelineMemoryStore}
            link={LINK_CHATBOT_GUIDELINES}
            message='Review our AI Agent guidelines'
          />
        )}
        <ChatbotLayoutContent isDraggingCondition={isDraggingCondition}>
          <ChatbotBody />
        </ChatbotLayoutContent>
      </ChatbotLayoutWrapper>
    </ChatbotLayout>
  )
})

const ChatbotNewDialog = () => (
  <DialogLayout>
    <div className={styles.dialog}>
      <DialogEmpty />
    </div>
  </DialogLayout>
)

export const ChatbotNewPage = () => (
  <ChatbotProvider>
    <ChatbotDialogProvider>
      <ChatbotEditHead />
      <RootLayout>
        <ChatbotNew />
        <ChatbotNewDialog />
      </RootLayout>
    </ChatbotDialogProvider>
  </ChatbotProvider>
)
